<template>
  <div class="field">
    <div class="field">
      <div class="control has-icons-left is-clearfix">
        <input
          ref="input"
          :value="adress"
          :placeholder="placeholder"
          type="text"
          name="name"
          class="input"
          :disabled="disabled"
        >
        <span class="icon is-left">
          <i class="mdi mdi-map-marker mdi-24px" />
        </span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'GMapPlacesInput',
  props: {
    place: {
      type: Object,
      default: null
    },
    placeholder: {
      type: String,
      default: null
    },
    adress: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  mounted () {
    if (typeof (window.google.maps.places.Autocomplete) !== 'function') {
      throw new Error('google.maps.places.Autocomplete is undefined. Did you add \'places\' to libraries when loading Google Maps?')
    }

    this.$autocomplete = new window.google.maps.places.Autocomplete(this.$refs.input);
    // https://developers.google.com/maps/documentation/javascript/reference/places-service#PlaceResult.address_components
    this.$autocomplete.setFields(['formatted_address', 'geometry', 'name']);

    this.$autocomplete.addListener('place_changed', () => {
      let gPlace = this.$autocomplete.getPlace();

      if (gPlace.geometry.location) {
        let latLng = `${gPlace.geometry.location.lat()},${gPlace.geometry.location.lng()}`
        gPlace.latlng = latLng;
        this.$emit('update:place', gPlace);
      }
    });
  }
}
</script>
